export * from '@preact/signals-react';

export type SignalMethodOptions<T> = Readonly<{
  defaultValue: T;
}>;
